import {
	EVENT_ACTION_PARKING_AVAILABILITY_SELECTED_EXIT_DATE,
	EVENT_CATEGORY_PARKING_AVAILABILITY,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackSelectedExitDate(exitDate: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_AVAILABILITY,
		action: EVENT_ACTION_PARKING_AVAILABILITY_SELECTED_EXIT_DATE,
		label: exitDate,
	});
}
